import { createApp } from '@backstage/frontend-defaults';
import { convertLegacyAppOptions } from '@backstage/core-compat-api';
import { SignInPage } from '@backstage/core-components';
import { oktaAuthApiRef } from '@backstage/core-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import homePlugin from './homePlugin';
import { navModule } from './modules/nav';
import { themeModule } from './theme';
import { scaffolderOverrideModule } from './modules/scaffolderOverride';

const authFeature = convertLegacyAppOptions({
  components: {
    SignInPage: props => (
      <SignInPage
        {...props}
        auto
        provider={{
          id: 'okta',
          title: 'Okta',
          message: 'Signing in with Okta...',
          apiRef: oktaAuthApiRef,
        }}
      />
    ),
  },
});

export default createApp({
  features: [catalogPlugin, scaffolderPlugin, homePlugin, navModule, themeModule, authFeature, scaffolderOverrideModule],
});
